// extracted by mini-css-extract-plugin
module.exports = {"shelfManufacturingItems":"ShelfItemDetails_shelfManufacturingItems__pLiAd"};